import React, { type JSX, type ReactNode } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export type DetailFieldProps = {
  label: string;
  children: ReactNode;
};

export const DetailFieldEmptyValue = (): JSX.Element => (
  <Typography variant='bodyRegular' color='text.disabled'>
    -
  </Typography>
);

export type DetailFieldValueProps = {
  id?: string;
  children: ReactNode;
};

export const DetailFieldValue = ({ id, children }: DetailFieldValueProps): JSX.Element => (
  <Typography id={id} variant='bodyRegular' component='div'>
    {children}
  </Typography>
);

export const DetailField = ({ label, children }: DetailFieldProps): JSX.Element => (
  <Stack gap={0.5}>
    <Typography variant='captionRegular' color='text.secondary'>
      {label}
    </Typography>
    {children}
  </Stack>
);

export type DetailFieldRowProps = {
  children: ReactNode;
};

export const DetailFieldRow = ({ children }: DetailFieldRowProps): JSX.Element => (
  <Stack direction={{ xs: 'column', md: 'row' }} gap={{ xs: 2, md: 4 }} alignItems='flex-start' flexWrap='wrap'>
    {children}
  </Stack>
);
